// Единственные действительные учетные данные для MAS-IOT
export const validCredentials = {
    username: 'admin',
    password: 'admin123'
};

// Информация о системе
export const systemInfo = {
    name: 'MAS-IOT',
    fullName: 'Monitoring and Automation System - Internet of Things',
    version: '1.0.0',
    description: 'Система мониторинга и управления IoT-устройствами'
};

// Проверка учетных данных
export const validateCredentials = (username, password) => {
    return username === validCredentials.username &&
        password === validCredentials.password;
};

// Получение информации о пользователе admin
export const getAdminUser = () => {
    return {
        username: 'admin',
        role: 'admin',
        name: 'Администратор MAS-IOT',
        email: 'admin@mas-iot.local',
        department: 'Администрация',
        permissions: ['all']
    };
};